<template>
  <section
    id="instrumente"
    class="d-none d-md-block bg-instrumente position-relative"
  >
    <div class="container-fluid  align-items-start">
      <div class="container text-center">
        <div class="row align-items-center">
          <div class="col-12">
            <h2
              class="productheadlineh2 wow fadeInDown systemVariableOneSourceHeadline"
            >
              {{ $t("system_variable_one_source") }}
            </h2>
          </div>
        </div>
        <div class="row ">
          <div class="col-6 ">
            <h2
              class="smokeheadlineh2 wow fadeInLeft instrumentsAndAccessoiresHeadline"
            >
              {{ $t("instruments") }}<br />

              <LabeledButton
                :label="$t('Learn_more')"
                :onClick="
                  event => {
                    event.preventDefault();
                    toggleVisibility('Menu1');
                  }
                "
              />
            </h2>
          </div>
          <div class="col-6">
            <h2
              class="smokeheadlineh2 wow fadeInRight instrumentsAndAccessoiresHeadline"
            >
              {{ $t("accessoires") }}<br />

              <LabeledButton
                :label="$t('Learn_more')"
                :onClick="
                  event => {
                    event.preventDefault();
                    toggleVisibility('Menu2');
                  }
                "
              />
            </h2>
          </div>
        </div>

        <InstrumentsMenu1
          :toggle="toggleVisibility"
          :isVisible="isMenuVisible('Menu1')"
        />
        <InstrumentsMenu2
          :toggle="toggleVisibility"
          :isVisible="isMenuVisible('Menu2')"
        />
      </div>
    </div>

    <div class="position-absolute buttonFilmComaparisonWrapper">
      <VideoComponent name="test_with_competitor_products">
        <VideoIcon />
        <p class="videoButtonTitleFonts">
          {{ $t("Instruments_video_buttonTitle") }}
        </p>
      </VideoComponent>
    </div>
  </section>
</template>

<script>
import InstrumentsMenu1 from "./InstrumentsMenu1";
import InstrumentsMenu2 from "./InstrumentsMenu2";
import VideoComponent from "@/components/VideoComponent";
import LabeledButton from "@/components/LabeledButton";
import VideoIcon from "@/components/VideoIcon";
export default {
  name: "InstrumentsSection",
  data() {
    return {
      visibleDivId: null
    };
  },
  components: {
    InstrumentsMenu1,
    InstrumentsMenu2,
    VideoComponent,
    LabeledButton,
    VideoIcon
  },
  methods: {
    toggleVisibility(divId) {
      if (this.visibleDivId === divId) {
        return;
      } else {
        this.visibleDivId = divId;
      }
    },

    isMenuVisible(divId) {
      if (this.visibleDivId === divId) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
#instrumente {
  overflow: hidden;
  height: 70rem;
  padding-top: 50px;
}

.buttonFilmComaparisonWrapper {
  bottom: 3vh;
  right: 3vw;
}

.instrumentsAndAccessoiresHeadline {
  padding-top: 80px;
  color: black;
  margin-bottom: 50px;
}
.systemVariableOneSourceHeadline {
  color: black;
  margin-top: 40px;
  letter-spacing: 3px;
}

.bg-instrumente {
  background-image: url(../../assets/images/background-instrumente.jpg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 56vw;
}

.videoButtonTitleFonts {
  margin-top: auto;
    margin-bottom: auto;
    margin-left: 1rem;
    min-width: 210px;
    max-width: 60vw;
}
</style>
